import { useDropzone } from 'react-dropzone'
import styled from 'styled-components'
import { useToasts } from '@geist-ui/react'

const MAX_THUMBNAIL_SIZE = 5 * 1024 * 1024 // 5M

const ContentDiv = styled.div`
  position: relative;
  padding-bottom: 25%;
  height: 0;
  overflow: hidden;

  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='19' ry='19' stroke='white' stroke-width='3' stroke-dasharray='12' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 19px;
`

const ThumbnailImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 19px;
  background-color: #232323;
  justify-content: center;
  align-items: center;
  display: flex;
  object-fit: cover;
  overflow: hidden;
`

const IconWrapDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;
`

const Wrapper = styled.div`
  width: 100%;
  height: fit-content;
  cursor: pointer;
`

const UploadIcon = styled.img`
  height: 30px;
  width: 30px;
  object-fit: contain;
`

export interface Props {
  value?: File
  onChange: (file: File) => void
  arweave?: string
}

const BannerUpload = ({ value, onChange, arweave }: Props): JSX.Element => {
  const [, setToast] = useToasts()
  const { getRootProps, getInputProps } = useDropzone({
    accept: ['image/jpeg', 'image/png'],
    maxFiles: 1,
    noClick: false,
    noKeyboard: true,
    onDropAccepted: (files) => {
      const file = files[0]
      if (!file) {
        return
      }

      if (file.size > MAX_THUMBNAIL_SIZE) {
        setToast({ text: 'The file size should be smaller than 5MB!', type: 'error' })
        return
      }

      onChange(file)
    },
    // onDropRejected: () => {
    //   setToast({ text: 'Dimensions must be 1:4', type: 'error' })
    // },
    getFilesFromEvent: async (event: any) => {
      const files = event.target.files || event.dataTransfer.files
      const promises = []
      for (let index = 0; index < files.length; index++) {
        const file = files[index]
        const promise = new Promise((resolve) => {
          const image = new Image()
          image.onload = function () {
            file.width = image.width
            file.height = image.height
            resolve(file)
          }
          const url = URL.createObjectURL(file)
          image.src = url
        }) as Promise<File>
        promises.push(promise)
      }
      return await Promise.all(promises)
    },
    // validator: (file: any) => {
    //   // You can access width/height properties
    //   if (file.width !== 4 * file.height) {
    //     return {
    //       code: 'invalid-dimensions',
    //       message: `Dimensions must be 1:4`,
    //     }
    //   }
    //   return null
    // },
  })

  return (
    <Wrapper {...getRootProps()}>
      <input {...getInputProps()} />
      <ContentDiv>
        {value && <ThumbnailImg src={URL.createObjectURL(value)} />}
        {!value && arweave && (
          <ThumbnailImg
            src={`https://glassimg.imgix.net/${arweave}` + `?h=500&crop=fill&fm=webp`}
          />
        )}
        <IconWrapDiv>
          <UploadIcon src="/icons/upload.png" />
        </IconWrapDiv>
      </ContentDiv>
    </Wrapper>
  )
}

export default BannerUpload
